/**
 * 공지사항 목록 테이블
 */
import React from 'react';
import { Notice } from '../../types/notice.types';
import { format } from 'date-fns';

interface NoticeTableProps {
    notices: Notice[];
    loading: boolean;
    onEdit: (notice: Notice) => void;
    onDelete: (noticeId: number) => void;
}

export const NoticeTable: React.FC<NoticeTableProps> = ({
                                                            notices,
                                                            loading,
                                                            onEdit,
                                                            onDelete
                                                        }) => {
    // 공지 상태 확인
    const getStatus = (notice: Notice): { label: string; className: string } => {
        const now = new Date();
        if (notice.useYn !== 'Y') {
            return { label: '비활성', className: 'badge-secondary' };
        }
        if (notice.startDate && now < notice.startDate) {
            return { label: '예정', className: 'badge-info' };
        }
        if (notice.startDate && notice.endDate && now >= notice.startDate && now <= notice.endDate) {
            return { label: '게시중', className: 'badge-success' };
        }
        if (notice.startDate && !notice.endDate && now >= notice.startDate) {
            return { label: '게시중', className: 'badge-success' };
        }
        if (notice.endDate && now > notice.endDate) {
            return { label: '종료', className: 'badge-secondary' };
        }
        return { label: '게시중', className: 'badge-success' };
    };

    if (loading) {
        return <div className="loading-container">로딩 중...</div>;
    }

    if (notices.length === 0) {
        return <div className="empty-container">등록된 공지사항이 없습니다.</div>;
    }

    return (
        <div className="table-container">
            <table className="data-table">
                <thead>
                <tr>
                    <th>번호</th>
                    <th>상태</th>
                    <th>대상</th>
                    <th>범위</th>
                    <th>제목</th>
                    <th>팝업</th>
                    <th>게시기간</th>
                    <th>작성자</th>
                    <th>등록일</th>
                    <th>관리</th>
                </tr>
                </thead>
                <tbody>
                {notices.map((notice) => {
                    const status = getStatus(notice);
                    return (
                        <tr key={notice.noticeId}>
                            <td>{notice.noticeId}</td>
                            <td>
                                      <span className={`badge ${status.className}`}>
                                          {status.label}
                                      </span>
                            </td>
                            <td>
                                      <span className={`badge ${notice.targetType === 'S' ? 'badge-primary' : 'badge-warning'}`}>
                                          {notice.targetTypeName}
                                      </span>
                            </td>
                            <td>{notice.targetScopeName}</td>
                            <td className="title-cell">{notice.title}</td>
                            <td>
                                      <span className={`badge ${notice.popupYn === 'Y' ? 'badge-danger' : 'badge-secondary'}`}>
                                          {notice.popupYn === 'Y' ? '표시' : '미표시'}
                                      </span>
                            </td>
                            <td>
                                {notice.startDate ? format(notice.startDate, 'yyyy-MM-dd HH:mm') : '-'}
                                {notice.endDate ? ` ~ ${format(notice.endDate, 'yyyy-MM-dd HH:mm')}` : ''}
                            </td>
                            <td>{notice.writerTypeName}</td>
                            <td>
                                {notice.insDate ? format(notice.insDate, 'yyyy-MM-dd HH:mm') : '-'}
                            </td>
                            <td>
                                <div className="action-buttons">
                                    <button
                                        className="btn btn-sm btn-outline"
                                        onClick={() => onEdit(notice)}
                                    >
                                        수정
                                    </button>
                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => onDelete(notice.noticeId)}
                                    >
                                        삭제
                                    </button>
                                </div>
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
};
